<template>
  <section class="metric-slide-number">
    <hr />
    <b-progress :value="score" variant="lima" :max="10"></b-progress>
    <div class="labels">
      <span
        v-for="label in labels"
        :key="label"
        :class="{ active: label === Math.floor(score) && !isEmpty }"
      >
        {{ label }}
      </span>
    </div>
  </section>
</template>

<script>
const props = {
  question: {
    type: Object,
    required: true,
  },
  isEmpty: {
    type: Boolean,
    required: false,
  },
}

export default {
  props,
  data() {
    return {
      labels: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    }
  },
  computed: {
    score: function() {
      return this.question.score
    },
    enabled: function() {
      return this.question.uniqueAnswers + this.question.skipped > 2
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.metric-slide-number {
  padding: 0 1.4rem 1.4rem;

  hr {
    margin-top: 0;
    margin-bottom: 2rem;
  }

  .progress {
    background: map-get($theme-colors, 'light');
    border: 1px solid map-get($theme-colors, 'gray-dark');
    border-radius: 30px;
    max-height: 12px;
  }

  .labels {
    color: map-get($theme-colors, 'gray03');
    display: inline-flex;
    justify-content: space-between;
    margin-top: 1rem;
    width: 100%;

    span {
      &.active {
        color: map-get($theme-colors, 'lima');
        font-weight: 500;
        transform: scale(1.5);
      }
    }
  }
}
</style>

<style lang="scss">
.metric-slide-number {
  .progress-bar {
    border-radius: 30px;
  }
}
</style>
